import { render, staticRenderFns } from "./chatCategory.vue?vue&type=template&id=6b211886&scoped=true"
import script from "./chatCategory.vue?vue&type=script&lang=js"
export * from "./chatCategory.vue?vue&type=script&lang=js"
import style0 from "./chatCategory.vue?vue&type=style&index=0&id=6b211886&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b211886",
  null
  
)

export default component.exports